import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { Permission } from '@benzinga/session';
import { PermissionsEnvironment } from './environment';

export class PermissionRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(PermissionsEnvironment).url, session, {
      authorizationSession: true,
      'x-device-key': true,
    });
  }

  public getPermissions = (): SafePromise<Permission[]> => {
    const url = this.URL('api/v1/permissions');
    return this.get(url);
  };
}
